import { Purchases as NativePurchases } from '@revenuecat/purchases-capacitor';
import { isNative } from './platform';

// Web opens a Stripe Customer Portal session through the app's API instead.
export async function getManagementUrl(): Promise<string | null> {
  if (!isNative()) return null;
  try {
    const { customerInfo } = await NativePurchases.getCustomerInfo();
    return customerInfo.managementURL ?? null;
  } catch {
    return null;
  }
}
